import React from 'react';
import { InputNumber } from '@nackle/paper';
import { useSelector } from 'react-redux';
import { getRemainingBudget } from 'app/app-dux/program-dux';

export function PointEntry ( props ) {
	const {
		name,
		ariaLabel,
		placeholder,
		inputRef,
		value,
		invalidPoints,
		disabled,
		onChange,
		onFocus,
		onBlur
	} = props;

	const remainingBudget = useSelector( getRemainingBudget );

	return (
		<div className='points-counter'>
			<div>
				<InputNumber
					name={ name }
					aria-label={ ariaLabel }
					ref={ inputRef }
					className={ remainingBudget < 0 || invalidPoints[ name ]  ? 'point-entry-error' : 'points' }
					onChange={ onChange }
					onFocus={ onFocus }
					onBlur={ onBlur }
					disabled={ disabled }
					step={ 1 }
					value={ value || '' }
					placeholder={ placeholder }
				/>
			</div>
		</div>
	);
}